import React, { useEffect, useState } from "react"
import { IoIosStats } from "react-icons/io"
import { FaShoppingBag, FaUserPlus } from "react-icons/fa"
import { MdCancel, MdDownloading } from "react-icons/md"
import { PiKeyReturnFill } from "react-icons/pi"
import { Row, Col } from "reactstrap"
import Miniwidget from "./Miniwidget"
import ApplicationsStatusChart from "./applications-status-chart"
import EmailSent from "./email-sent"
import MonthlyEarnings2 from "./montly-earnings2"
import Inbox from "./inbox"
import RecentActivity from "./recent-activity"
import WidgetUser from "./widget-user"
import YearlySales from "./yearly-sales"
import LatestTransactions from "./latest-transactions"
import LatestOrders from "./latest-orders"
import { useDispatch, useSelector } from "react-redux"
import {
  AllApplicationFetch,
  allApplications,
} from "redux/slice/applications/applicationSlice"
import ReturningApplications from "./returning-applications"
import LatestUpdates from "./latest-updated-applications"

const Dashboard = () => {
  document.title = "Shukre Ilahi"
  const dispatch = useDispatch()
  const { allApplicationsDataWithoutPagination, applicationsData } =
    useSelector(allApplications)
  const [statusCounts, setStatusCounts] = useState({
    Total: 0,
    New: 0,
    Process: 0,
    Accepted: 0,
    Hold: 0,
    Rejected: 0,
    Returning: 0,
  })

  useEffect(() => {
    dispatch(AllApplicationFetch({}))
  }, [dispatch])

  useEffect(() => {
    const countApplicationStatus = () => {
      const counts = {
        Total: allApplicationsDataWithoutPagination
          ? allApplicationsDataWithoutPagination?.length
          : 0,
        New: 0,
        Process: 0,
        Accepted: 0,
        Hold: 0,
        Rejected: 0,
        Returning: 0,
      }
      allApplicationsDataWithoutPagination.forEach(application => {
        const status = application?.applicationStatus
        if (counts.hasOwnProperty(status)) {
          counts[status]++
        }
        if (status?.replace(/\s/g, "").toLowerCase() === "inprocess") {
          counts["Process"]++
        }
      })
      setStatusCounts(counts)
    }
    if (
      allApplicationsDataWithoutPagination &&
      allApplicationsDataWithoutPagination?.length
    ) {
      countApplicationStatus()
    }
  }, [allApplicationsDataWithoutPagination])

  const reports = [
    {
      statusId: "New",
      title: "New Application",
      icon: <FaShoppingBag />,
      total: statusCounts.New,
      average:
        allApplicationsDataWithoutPagination?.length > 0
          ? (statusCounts.New / allApplicationsDataWithoutPagination?.length) *
            100
          : 0,
      badgecolor: "#f5b225",
    },
    {
      statusId: "In Process",
      title: "Process Application",
      icon: <IoIosStats />,
      total: statusCounts.Process,
      average:
        allApplicationsDataWithoutPagination?.length > 0
          ? (statusCounts.Process /
              allApplicationsDataWithoutPagination?.length) *
            100
          : 0,
      badgecolor: "#26b9e2",
    },
    {
      statusId: "Accepted",
      title: "Accepted Application",
      icon: <FaUserPlus />,
      total: statusCounts.Accepted,
      average:
        allApplicationsDataWithoutPagination?.length > 0
          ? (statusCounts.Accepted /
              allApplicationsDataWithoutPagination?.length) *
            100
          : 0,
      badgecolor: "#1abc9c",
    },
    {
      statusId: "Hold",
      title: "Hold Application",
      icon: <MdDownloading />,
      total: statusCounts.Hold,
      average:
        allApplicationsDataWithoutPagination?.length > 0
          ? (statusCounts.Hold / allApplicationsDataWithoutPagination?.length) *
            100
          : 0,
      badgecolor: "#6c757d",
    },
    {
      statusId: "Rejected",
      title: "Rejected Application",
      icon: <MdCancel />,
      total: statusCounts.Rejected,
      average:
        allApplicationsDataWithoutPagination?.length > 0
          ? (statusCounts.Rejected /
              allApplicationsDataWithoutPagination?.length) *
            100
          : 0,
      badgecolor: "#ec536c",
    },
    {
      statusId: "Returning",
      title: "Returning Application",
      icon: <PiKeyReturnFill />,
      total: statusCounts?.Returning,
      average:
        allApplicationsDataWithoutPagination?.length > 0
          ? (statusCounts?.Returning /
              allApplicationsDataWithoutPagination?.length) *
            100
          : 0,
      badgecolor: "#d68b44",
    },
  ]

  return (
    <React.Fragment>
      <Miniwidget reports={reports} />

      <Row>
        <Col xl="4">
          <ApplicationsStatusChart
            reports={reports}
            statusCounts={statusCounts}
            total={statusCounts.Total}
          />
        </Col>

        <Col xl="8">
          <LatestUpdates
            allApplicationsDataWithoutPagination={
              allApplicationsDataWithoutPagination
            }
          />
        </Col>

        {/* <Col xl="6">
          <LatestOrders
            allApplicationsDataWithoutPagination={
              allApplicationsDataWithoutPagination
            }
          />
        </Col>
        <Col xl="6">
          <ReturningApplications
            allApplicationsDataWithoutPagination={
              allApplicationsDataWithoutPagination
            }
          />
        </Col> */}

        {/* <Col xl="6">
          <EmailSent />
        </Col> */}

        {/* <Col xl="3">
          <MonthlyEarnings2 />
        </Col> */}
      </Row>

      {/* <Row>
        <Col xl="4" lg="6">
          <Inbox />
        </Col>
        <Col xl="4" lg="6">
          <RecentActivity />
        </Col>
        <Col xl="4">
          <WidgetUser />
          <YearlySales />
        </Col>
      </Row> */}

      {/* <Row>
        <Col xl="6">
          <LatestTransactions />
        </Col>

        <Col xl="6">
          <LatestOrders applicationsData={applicationsData} />
        </Col>
      </Row> */}
    </React.Fragment>
  )
}

export default Dashboard